import React from 'react';
import FadeInImage from 'components/FadeInImage';
import { GenericButton } from 'components/GenericButton';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import { ProfilesHeader } from '../ProfilesHeader';
import {
  SET_PROFILE_FORM_FIELD,
  SET_PROFILE_LAYOUT_TYPE,
} from 'containers/ProfileManager/redux/profile.types';
import './style.scss';
import { deleteProfile } from 'containers/ProfileManager/redux/profile.actions';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { MobileGenericHeader } from 'components/MobileGenericHeader';

export const DeleteProfileView = () => {
  const dispatch = useDispatch();
  const { isMobile } = useVerifyIsMobile(768);
  const translations = useSelector(state => state.translations);
  const {
    configProfileForm: { gamification_id },
    profilesInfo: { members },
    prevLayout,
  } = useSelector(state => state.profilesManager);
  const currentProfile = members?.find(
    member => member.gamification_id === gamification_id,
  );

  if (!currentProfile) return null;

  const { user_image, username, is_kids } = currentProfile;

  const resetForm = () =>
    dispatch({
      type: SET_PROFILE_FORM_FIELD,
      payload: {
        user_image,
        is_kids: is_kids === 'false' ? false : true,
        firstname: username,
        gamification_id,
      },
    });

  const handleDeleteProfile = () => {
    dispatch(deleteProfile({ gamification_id }));
    resetForm();
  };

  const handleCancelClick = () => {
    resetForm();
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: prevLayout });
  };

  return (
    <>
      {!isMobile && <ProfilesHeader />}
      <section className="delete-profile-view profiles-common__container fade__in">
        {isMobile ? (
          <MobileGenericHeader
            onBack={handleCancelClick}
            caption={getTranslation(
              'deleteProfile_access_title_label',
              translations,
            )}
          />
        ) : (
          <h2 className="delete-profile-view__title profiles-common__container__title delete-profile-view__mb-57 ">
            {getTranslation('deleteProfile_access_title_label', translations)}
          </h2>
        )}
        <div className="delete-profile-view__content">
          <FadeInImage
            imageAlt="cv-profile-img"
            imageSrc={user_image}
            width={144}
            height={144}
            classNames={['delete-profile-view__content__img']}
          />
          <span className="delete-profile-view__content__profile-name">
            {username}
          </span>
          <p className="delete-profile-view__content__label">
            {getTranslation(
              'deleteProfile_access_description_label',
              translations,
            )}
          </p>
        </div>
        <div className="delete-profile-view__options">
          <GenericButton
            classNames={['delete-profile-view__options__buton']}
            textContent={getTranslation(
              'deleteProfile_access_option_button_delete',
              translations,
            )}
            type="primary"
            onClick={handleDeleteProfile}
          />
          <GenericButton
            classNames={['delete-profile-view__options__buton']}
            textContent={getTranslation(
              'deleteProfile_access_option_button_cancel',
              translations,
            )}
            type="secondary"
            onClick={handleCancelClick}
          />
        </div>
      </section>
    </>
  );
};
